<template>
  <div class="container py-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h3 class="m-0">Company Settings</h3>
      <div>
        <button class="btn btn-primary" @click="openAdd">Add Setting</button>
      </div>
    </div>

    <div class="card">
      <div class="card-body p-0">
        <table class="table table-sm table-striped mb-0">
          <thead class="thead-light">
            <tr>
              <th>Category</th>
              <th>Setting Name</th>
              <th>Key</th>
              <th>Value</th>
              <th>Description</th>
              <th>Status</th>
              <th style="width: 110px">Actions</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="item in settings" :key="item.id">
              <td>{{ item.setting_category_name }}</td>
              <td>{{ item.setting_name }}</td>
              <td>
                <code>{{ item.setting_key }}</code>
              </td>
              <td>{{ item.setting_value }}</td>
              <td>{{ item.description }}</td>
              <td>
                <span
                  v-if="item.status == 1 || item.status === 'active'"
                  class="badge bg-success"
                  >Active</span
                >
                <span v-else class="badge bg-secondary">Inactive</span>
              </td>
              <td>
                <button
                  class="btn btn-sm btn-outline-primary me-1"
                  @click="openEdit(item)"
                >
                  Edit
                </button>
                <button
                  class="btn btn-sm btn-outline-danger"
                  @click="confirmDelete(item)"
                >
                  Delete
                </button>
              </td>
            </tr>

            <tr v-if="settings.length === 0">
              <td colspan="7" class="text-center py-4">No settings found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Setting Modal -->
    <SettingModal
      v-if="modalVisible"
      :mode="modalMode"
      :editData="editData"
      :settingsTree="settingsTree"
      @close="modalVisible = false"
      @saved="handleSaved"
    />
  </div>
</template>

<script>
import SettingModal from "./SettingModal.vue";
// import { generalApiRequest } from "@/utils/api"; // adjust path to your helper
import { generalApiRequest } from "../../../api/apiIndex";

export default {
  name: "CompanySettings",

  components: { SettingModal },

  data() {
    return {
      settings: [],
      settingsTree: {},

      modalVisible: false,
      modalMode: "create", // 'create' or 'edit'
      editData: null,
    };
  },

  methods: {
    async fetchSettings() {
      try {
        const url = "company-settings";
        const response = await generalApiRequest(url, "GET", {}, 1);

        // Expect response.data to have saved_settings and settings_tree
        console.log(response);

        this.settings = (response && response.saved_settings) || [];
        this.settingsTree = (response.data && response.settings_tree) || {};
      } catch (err) {
        console.error("fetchSettings error:", err);
      }
    },

    openAdd() {
      this.modalMode = "create";
      this.editData = null;
      this.modalVisible = true;
    },

    openEdit(item) {
      this.modalMode = "edit";
      // Pass entire DB row to modal so it can prefill
      this.editData = { ...item };
      this.modalVisible = true;
    },

    async confirmDelete(item) {
      if (!confirm(`Delete setting "${item.setting_name}"?`)) return;

      try {
        const url = `company-settings/${item.id}`;
        await generalApiRequest(url, "DELETE", {}, 1);
        this.fetchSettings();
      } catch (err) {
        console.error("delete error:", err);
        alert("Failed to delete setting");
      }
    },

    handleSaved() {
      this.modalVisible = false;
      this.fetchSettings();
    },

    // find category name by setting_key using settingsTree
    getCategoryName(settingKey) {
      if (!this.settingsTree) return null;

      for (const [catKey, cat] of Object.entries(this.settingsTree)) {
        if (!cat || !cat.children) continue;
        // children is an object keyed by child key (e.g., "default_currency")
        for (const [childKey, childDef] of Object.entries(cat.children)) {
          console.log(childKey);

          if (childDef && childDef.setting_key === settingKey) {
            return cat.category_name || catKey;
          }
        }
      }
      return null;
    },
  },

  mounted() {
    this.fetchSettings();
  },
};
</script>

<style scoped>
.container {
  max-width: 1100px;
}
.table code {
  font-size: 0.9em;
}
</style>
